<template>
	<div class="manager-profile">
		<div class="vx-row">
			<div class="vx-col w-full mb-5">
				<vx-card class="manager-profile__card">
					<vs-tabs>
						<vs-tab :label="$t('profile')">
							<div class="info mt-5 flex-col md:flex-row">
								<div class="photo">
									<img :src="$store.state.auth.user.photo" alt="">
								</div>
								<div class="data mt-10 md:mt-0">
									<div class="tables vx-row">
										<table class="vx-col">
											<tbody>
											<tr>
												<td>{{ $t('personName') }}</td>
												<td>{{$store.state.auth.user.first_name }} {{$store.state.auth.user.last_name }}</td>
											</tr>
											<tr>
												<td>Email</td>
												<td>{{$store.state.auth.user.email }}</td>
											</tr>
											<tr>
												<td>{{ $t('emailForPayment') }}</td>
												<td>{{$store.state.auth.user.email_payment }}</td>
											</tr>
											<tr>
												<td>{{ $t('phone') }}</td>
												<td>{{$store.state.auth.user.phone }}</td>
											</tr>
											</tbody>
										</table>
										<table class="vx-col">
											<tbody>
											<tr>
												<td>{{ $t('birthDate') }}</td>
												<td>{{$store.state.auth.user.birth_date }}</td>
											</tr>
											<tr>
												<td>{{ $t('sex') }}</td>
												<td>{{ $getDeep($store.state.auth.user.gender, genders) }}</td>
											</tr>
											<tr>
												<td>{{ $t('country') }}</td>
												<td>{{ $getDeep($store.state.auth.user.country, countries) }}</td>
											</tr>
											<tr>
												<td>{{ $t('language') }}</td>
												<td>
													<div class="d-flex flex-wrap">
														{{ languagesOutput }}
													</div>
												</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<vs-button
								@click="$router.push('/profile/edit')"
								class="mt-10 edit-btn"
							>{{ $t('edit') }}</vs-button>
						</vs-tab>
						<vs-tab :label="$t('sitesPreferences')">
							<ManagerSites
								:manager="$store.state.auth.user"
							/>
						</vs-tab>
					</vs-tabs>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import ManagerSites from "@/components/profile/ManagerSites";

export default {
	name: "Supervisor",
	components: {
		ManagerSites
	},
	data() {
		return {
			popupActive: false,
			val: '',
			description: '',
			countries: [],
			genders: [],
			languages: [],
			subjects: []
		}
	},
	computed: {
		languagesOutput() {
			let output = [];
			const languages = this.$store.state.auth.user.languages;

			if(!languages) return [];

			for(let lang of this.$store.state.auth.user.languages) {
				output.push(this.$getDeep(lang, this.languages));
			}
			return output.join(", ");
		}
	},
	async mounted() {
		try {
			this.languages = (await this.$http.get('/settings/get-languages')).data.data;
			this.subjects =  (await this.$http.get('/settings/get-subjects')).data.data;
			this.countries = (await this.$http.get('/settings/get-countries')).data.data
			this.genders = (await this.$http.get('/settings/get-genders')).data.data;
			let res = await this.$http('/'+this.$store.state.auth.role+'/profile');
		} catch (e) {

		}
	},
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.manager-profile {
	&__card {
		max-width: 1200px;
	}

	.data{
		width: 100%;
	}
	.feature {
		span {
			color: $success;
		}

		.vx-card__body {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		strong {
			font-size: rem(18px);

			b {
				color: $danger;
			}
		}
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}

	.vx-card {
		height: 100%;
	}


	table {
		margin-bottom: 20px;
		padding-left: 15px;
		max-width: 465px;
		width: 100%;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					width: 40%;
					font-weight: 600;
				}
			}
		}
	}

	.info {
		display: flex;

		.tables {
			display: flex;
			&>table{
				&:first-child{
					margin-right: 0 !important;
				}
			}
		}

		.about {
			display: flex;
			margin-left: 20px;

			b {
				flex-shrink: 0;
				width: 250px;
			}
		}
	}

	.photo {
		width: 200px;
		height: 200px;
		border-radius: 10px;
		overflow: hidden;
		margin: 15px 15px;
		margin-left: 0;
		flex-shrink: 0;
		margin-right: 35px;


		img {
			max-width: 100%;
			width: 100%;
			height: 100%;
		}
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}

	.edit-btn {
		width: 100%;
		max-width: 200px;
	}

	@media screen and (max-width: 576px) {
		tr {
			td:first-child {
				width: 50% !important;
			}
		}
	}
}

</style>
